<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        created() {
            let url = 'https://365jiaju.net/';
            console.log("欢迎您的加入，由度家居%o", url);
        }
    }
</script>
<style>
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css"; /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/

    .el-pagination {
        margin-top: 30px;
    }

    /*解决element-ui 的table组件 表格线条不对齐*/
    body .el-table th.gutter {
        display: table-cell !important;
    }

    /*解决table组件线条消失或重复*/
    .el-table .cell {
        line-height: normal !important;
    }

    /*.el-table::before {*/
    /*height: 0 !important;*/
    /*}*/

    .el-table__fixed-right::before {
        height: 0 !important;
    }

    .el-table::before {
        z-index: inherit !important;
    }

    .container {
        margin-left: 0;
        min-height: 570px;
    }

</style>
